import { smartAxios } from "../axios/Axios";
import { CONNECT_ENDPOINTS } from "./connectEndpoints";

 

interface ITelegramVerifyModel {
  id: number;
  code: string;
}

interface ITelegramPasswordModel {
  id: number;
  password: string;
}

export const postConnectTelegramPhone = (phoneNumber: string) => {
  return smartAxios.post(CONNECT_ENDPOINTS.postConnectTelegramPhone, {
    phone_number: phoneNumber,
  });
};

export const postVerifyTelegramCode = (verifyData: ITelegramVerifyModel) => {
  return smartAxios.post(
    `${CONNECT_ENDPOINTS.postConnectTelegramPhone}${verifyData.id}/verify-code/`,
    { code: verifyData.code },
  );
};

export const postPasswordTelegram = (passwordData: ITelegramPasswordModel) => {
  return smartAxios.post(
    `${CONNECT_ENDPOINTS.postConnectTelegramPhone}${passwordData.id}/verify-2fa/`,
    { password: passwordData.password },
  );
};

export const postConnectWhatsAppPhone = (phoneNumber: string) => {
  return smartAxios.post(CONNECT_ENDPOINTS.postConnectWhatsAppPhone, {
    phone_number: phoneNumber,
  });
};
export const postConnectWhatsAppCheck = (id: number) => {
  return smartAxios.post(CONNECT_ENDPOINTS.postConnectWhatsAppCheck, {
    instance_id: id,
  });
};
export const deleteConnectWhatsAppDisconnect = () => {
  return smartAxios.delete(CONNECT_ENDPOINTS.deleteConnectWhatsAppDisconnect);
};
